import { defineComponent as f, computed as s } from "vue";
import { MsStarEmpty as r, MsStarHalf as i, MsStarFilled as m } from "@sunrise/icons";
const d = f({
  name: "MsStarsRating",
  components: {
    MsStarFilled: m,
    MsStarHalf: i,
    MsStarEmpty: r
  },
  props: {
    rating: {
      default: 0,
      type: Number
    },
    maxRating: {
      default: 5,
      type: Number
    },
    yellowEmptyStars: {
      default: !1,
      type: Boolean
    }
  },
  setup(t) {
    const o = s(() => {
      const n = t.rating, u = t.maxRating, e = [];
      for (let a = 0; a < u; a++)
        n >= a + 1 ? e.push(m) : n >= a + 0.3 ? e.push(i) : e.push(r);
      return e;
    }), l = s(() => t.rating < 0.3 ? "" : new Intl.NumberFormat("de-DE", {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1
    }).format(t.rating));
    return {
      stars: o,
      label: l,
      MsStarEmpty: r
    };
  }
});
export {
  d as default
};
